import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ValueProps } from './components/ValueProps';
import { Portfolio } from './components/Portfolio';
import { Pricing } from './components/Pricing';
import { Process } from './components/Process';
import { Faq } from './components/Faq';
import { StartSection } from './components/StartSection';
import { FinePrint } from './components/FinePrint';
export function App() {
  return <div className="w-full bg-brand-white font-sans text-brand-black antialiased" data-id="element-0" data-mp="2riklx1c3g39f">
      <Header data-id="element-1" data-mp="2mjpvpebsrcfa" />
      <main data-id="element-2" data-mp="2mjzp7bw1w1pq">
        <Hero data-id="element-3" data-mp="31agoaol7qfjg" />
        <ValueProps data-id="element-4" data-mp="31aysc7e49y1x" />
        <Portfolio data-id="element-5" data-mp="31bi9hlvy0iew" />
        <Pricing data-id="element-6" data-mp="31c1igd3m7wgs" />
        <Process data-id="element-7" data-mp="31cjp83nwlt2y" />
        <Faq data-id="element-8" data-mp="2wka0gqyiyz29" />
        <StartSection data-id="element-9" data-mp="2wjqhd6x524mn" />
      </main>
      <FinePrint data-id="element-10" data-mp="2wifc12o1ootf" />
    </div>;
}